module.exports = __webpack_public_path__ + "img/tongcheng_icon_active.ef7fa6ab.png";